<template>
    <v-app :style="getStyle_App()">
        <v-container class="ma-0 pa-0 theme-backcolor" fluid>
            <v-row align="center" class="ma-0 pa-0" justify="center" v-if="project.uxd.hideheader == '0'">
                <v-col class="ma-0 pa-0">
                    <v-app-bar elevation="0" id="top-toolbar" class="theme-barbackcolor" height="120px">
                        <div v-if="noCookies()" style="color:red">Please enable cookies in your browser</div>
                        <div v-else>
                          <div style="display: flex; flex-grow: 1; align-items: center;">
                              <a :href="project.uxd.watermarkurl" :style="project.uxd.watermarkstyle" class="theme-fontname" target="_blank">{{project.uxd.watermark}}</a>
                              <v-toolbar-title id="top-toolbar-title" class="mr-6" v-if="project.uxd.headerlayout.includes('title')">
                                  <a :href="project.uxd.logonav" target="_top">
                                      <img class="container_client_logo" :title="project.uxd.logoalt"
                                           :src="project.uxd.logoimg">
                                  </a>
                              </v-toolbar-title>
                              <div id="top-toolbar-nav" class="top-toolbar-item ml-6 mr-6" v-if="project.uxd.headerlayout.includes('nav')">
                                  <div @click="levelUp()">
                                      <v-icon left class="theme-barfontcolor">mdi-chevron-left</v-icon>
                                      <span class="theme-barfontcolor theme-fontname">{{project.uxd.labelback}}</span>
                                  </div>
                              </div>
                              <div id="top-toolbar-search" class="top-toolbar-item ml-6 mr-6" v-if="project.uxd.headerlayout.includes('search')">
                                  <v-icon @click="doSearch" left class="theme-barfontcolor">mdi-magnify</v-icon>
                                  <input  id="layerSearchBox"
                                          type="text"
                                          v-model="searchText"
                                          @keyup.enter="doSearch"
                                          class="theme-searchinput theme-fontname"
                                          style="color:blue"
                                          :placeholder="project.uxd.searchplaceholder"/>
                                  <v-checkbox id="top-toolbar-search-withinscope" :title="project.uxd.labelsearchview" @click="doSearchDelayed"></v-checkbox>
                                  <v-progress-circular v-if="project.searchLoading" color="blue-grey" indeterminate :size="24"></v-progress-circular>
                              </div>
                              <div id="top-toolbar-email" class="top-toolbar-item ml-6 mr-6" v-if="(project.uxd.ordercontext == '_email' || project.uxd.quotecontext == '_email') && project.uxd.headerlayout.includes('email')">
                                  <div>
                                      <v-icon @click="prepareEmail" left class="theme-barfontcolor">mdi-email</v-icon>
                                      <span id="countEmailItems" class="theme-barfontcolor theme-fontname ml-2">0</span>
                                  </div>
                              </div>
                              <v-menu v-if="project.locales.length > 1 && project.uxd.headerlayout.includes('languages')" offset-y>
                                  <template v-slot:activator="{ on }">
                                      <div v-on="on"  id="top-toolbar-languages" class="top-toolbar-item ml-6 mr-6">
                                          <span class="theme-barfontcolor theme-fontname">{{project.selectedLocale}}</span>
                                          <v-icon right class="theme-barfontcolor">mdi-chevron-down</v-icon>
                                      </div>
                                  </template>
                                  <v-list style="background-color:#fff" class="theme-fontname">
                                      <v-list-item v-for="item in project.locales" :key="item.languagecode"
                                                   @click="doSelectLocale(item.languagecode)">
                                          <v-list-tile-title v-text="item.name">
                                          </v-list-tile-title>
                                      </v-list-item>
                                  </v-list>
                              </v-menu>
                              <div style="flex-grow: 1"></div>
                              <!-- <div style="width: 100px; height: 1px;"></div>-->
                          </div>
                          <div v-if="mobile"
                               class="close_tab theme-tabbackcolor" style="display: block;">
                              <div class="close_tab_close_button" @click="closeApp">
                                  <span class="mdi mdi-close">
                                  </span>
                              </div>
                          </div>
                      </div>
                    </v-app-bar>
                </v-col>

            </v-row>
            <v-row class="breadcrumb-wrapper flex-nowrap ma-0">
                <BreadCrumb></BreadCrumb>
            </v-row>
            <v-row class="content-wrapper lmt-2 ml-0 mr-0 mb-0 pa-0 d-flex flex-nowrap">
                <v-col :style="getStyle_LeftPane(windowWidth, project.uxd.listwidth)"
                       v-if="isLeftPaneVisible"
                       class="left-pane  pa-0 ml-5"
                       v-bind:class="{ 'open': !session.leftPaneCollapsed }">
                    <div style="position: relative">
                        <div @click="closeLeftPane"
                             class="left-pane_list_close layer_round_icon button-iconbackcolor button-iconfontcolor">
                            <v-icon class="theme-iconfontcolor">mdi-close</v-icon>
                        </div>
                        <ProjectTree></ProjectTree>
                        <PartsGrid v-if="isDrawingVisible"></PartsGrid>
                    </div>
                </v-col>
                <v-col class="lml-2 lpt-0 lmt-0 left-pane-collapsed"
                       v-if="isLeftPaneVisible"
                       @click="openLeftPane">
                    <div style="background-color: white; height: 56px; width: 56px; display: flex; align-items: center;justify-content: center;">
                        <div class="layer_round_icon button-iconbackcolor button-iconfontcolor">
                            <v-icon>mdi-format-list-bulleted-square</v-icon>
                        </div>
                    </div>
                </v-col>

                <v-col class="main-view-wrapper pa-0" :style="getStyle_MainViewWrapper()">
                    <router-view></router-view>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model="orderDialog" width="320" transition="v-scale-transition">
          <template v-slot:activator="{ props: activatorProps }"></template>
          <v-card>
            <v-card-title class="theme-tabbackcolor"><img :src="this.project.uxd.shopicon" style="width:34px;height:34px;"></v-card-title>
            <v-card-text>
              <br/>
              <v-text-field v-model="orderColumnValue" id="quantityField" :label="this.project.orderColumnLabel" autocomplete="off" autofocus></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="submitOrderValue">{{project.uxd.labelok}}</v-btn>
              <v-btn color="primary" text @click="orderDialog = false">{{project.uxd.labelcancel}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="searchDialog" width="320" transition="v-scale-transition">
          <template v-slot:activator="{ props: activatorProps }"></template>
          <v-card>
            <v-card-title class="theme-tabbackcolor"><v-icon left>mdi-magnify</v-icon></v-card-title>
            <v-card-text>
              <br/>
              <v-text-field v-model="searchDialogValue" id="searchField" :label="this.project.uxd.searchplaceholder" autocomplete="off" autofocus></v-text-field>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="submitSearchValue">{{project.uxd.labelok}}</v-btn>
              <v-btn color="primary" text @click="closeSearch">{{project.uxd.labelcancel}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="localeDialog" width="320" transition="v-scale-transition">
          <template v-slot:activator="{ props: activatorProps }"></template>
          <v-card>
            <v-card-title class="theme-tabbackcolor"><v-icon left>mdi-web</v-icon></v-card-title>
            <v-card-text>
              <br/><br/>
              <v-select
                :label="project.uxd.labellanguage"
                :items="project.locales"
                item-value="languagecode"
                item-text="name"
                :value="project.selectedLocale"
                 v-model="localeValue"
              ></v-select>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="submitLocale">{{project.uxd.labelok}}</v-btn>
              <v-btn color="primary" text @click="closeLocale">{{project.uxd.labelcancel}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>


    </v-app>
</template>
<style lang="scss">
    @import './assets/style.css';
</style>

<script>
    import PartsGrid from './components/PartsGrid.vue'
    import ProjectTree from './components/ProjectTree.vue'
    import {mapState, mapGetters, mapActions} from 'vuex'
    import {EventBus} from './services/event-bus.js'
    import dao from './dao'
    import BreadCrumb from "./components/BreadCrumb";

    export default {
        name: 'app',
        data() {
            return {
                mobile: false,
                windowWidth: window.innerWidth,
                localesOpen: false,
                searchText: '',
                orderDialog: false,
                orderColumnValue : '',
                orderFunc: null,
                searchDialog: false,
                searchDialogValue : '',
                localeDialog : false,
                localeValue : '',
                items: [
                    {icon: 'lightbulb_outline', text: 'Notes'},
                    {icon: 'touch_app', text: 'Reminders'}
                ]
            }
        },
        computed: {
            ...mapState([
                'project',
                'session'
            ]),
            isDrawerOpen: {
                get: function () {
                    return this.$store.getters.isDrawerOpen
                },
                set: function (val) {
                    this.updateDrawerOpen(val)
                }
            },
            ...mapGetters({
                isLeftPaneVisible: 'isLeftPaneVisible',
                isPartSelected: 'isPartSelected',
                isDrawingVisible: 'isDrawingVisible',
                isPartListVisible: 'isPartListVisible'
            })
        },
        components: {
            BreadCrumb,
            'PartsGrid': PartsGrid,
            'ProjectTree': ProjectTree
        },
        methods: {
            ...mapActions([
                'toggleDrawer',
                'hideDrawer',
                'getLocales',
                'getUXD',
                'selectLocale',
                'updateDrawerOpen',
                'levelUp',
                'closeLayer',
                'search',
                'openLeftPane',
                'closeLeftPane',
                'cleanupCookies',
                'notifyLayerLoaded',
                'processTaskMessage',
                'noCookies',
                'prepareEmail',
                'addToCart'
            ]),
            doSearchDelayed() {
              setTimeout(() => { this.doSearch() }, 500 );
            },
            async doSearch() {
              if (this.searchText.trim().length < 2) {
                this.searchText = "";
                this.project.searchLoading = false;
              } else {
                this.project.searchLoading = true;
                await this.search(this.searchText);
                this.project.searchLoading = false;
              }
            },
            toggleLangs() {
                this.localesOpen = !this.localesOpen
            },
            doSelectLocale(newLangCode) {
                this.selectLocale(newLangCode);
            },
            resetDrawing() {
              EventBus.$emit('reset-drawing', true);
            },
            zoominDrawing() {
              EventBus.$emit('zoomin-drawing', true)
            },
            zoomoutDrawing() {
                EventBus.$emit('zoomout-drawing', true)
            },
            exitApp() {
                this.closeLayer()
            },
            getParameterByName(name) {
                const url = window.location.href
                name = name.replace(/[[]]/g, '\\$&')
                let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
                let results = regex.exec(url)
                if (!results) return null
                if (!results[2]) return ''
                return decodeURIComponent(results[2].replace(/\+/g, ' '))
            },
            setSearchText(searchText) {
              this.searchText = searchText;
            },
            appendTheme() {
              if(this.project.uxd.themecss) {
                let file = document.createElement('link');
                file.rel = 'stylesheet';
                file.href = this.project.uxd.themecss;
                document.head.appendChild(file);
              }
            },
            getStyle_LeftPane(winWidth, projWidth) {
              let css = '';
              if (winWidth < 1050) {
                  css += 'width: 100vw; max-width: 100vw;';
              } else {
                  css += `width: ${projWidth}px; max-width: ${projWidth}px;`;
              }
              if(this.project.uxd.hideheader == '1') {
                css += 'height: calc(100vh - 80px);max-height: calc(100vh - 80px)';
              } else {
                css += 'height: calc(100vh - 210px);max-height: calc(100vh - 210px)';
              }
              return css;
            },
            onResize() {
                this.windowWidth = window.innerWidth
            },
            closeApp() {
              if(this.project.uxd.emptyorderbasket)
                sessionStorage.removeItem("orderscriptcalls");
              if(this.project.uxd.emptyquotebasket)
                sessionStorage.removeItem("quotescriptcalls");
              window.top.postMessage('pcgcloselayer', '*')
            },
            noCookies() {
              try {
                if(!window.sessionStorage) return true;
                window.sessionStorage.setItem('spl_test_cookie', 'test_value');
                let test = window.sessionStorage.getItem('spl_test_cookie');
                if(test == null || test != 'test_value') return true;
                window.sessionStorage.removeItem('spl_test_cookie');
                return false;
              } catch(err) {
                return true;
              }
            },
            handleOrientationChange() {
              const orientation = window.screen.orientation.type
              if (orientation === "portrait-primary") {
                // portrait mode
                location.reload();
              } else if (orientation === "landscape-primary") {
                // landscape mode
                location.reload();
              }
            },
            submitOrderValue() {
              this.orderDialog = false;
              this.project.orderColumnValue = this.orderColumnValue;
              this.addToCart(this.project.orderFunc);
              EventBus.$emit('refresh-drawing', true);
            },
            closeSearch() {
              this.searchDialog = false;
            },
            async submitSearchValue() {
              this.searchDialog = false;
              this.project.searchLoading = true;
              await this.search(document.getElementById("searchField").value);
              this.project.searchLoading = false;
            },
            closeLocale() {
              this.localeDialog = false;
            },
            submitLocale() {
              this.localeDialog = false;
              this.selectLocale(this.localeValue);
            },
            getStyle_MainViewWrapper() {
              return 'height: ' + (this.project.uxd.hideheader == '0'? 'calc(100vh - 200px)' : 'calc(100vh - 80px)');
            },
            getStyle_App() {
              return this.project.uxd.layerwidthmode != 'fixed' ? 'max-width: calc(100vw - ' + (parseInt(this.project.uxd.layerfullwidthmargin) * 2) + 'px)' : 'max-width: ' + this.project.uxd.layerfixedwidth + 'px';
            }
        },
        async created() {
            this.mobile = navigator.userAgent.match(/(android|iphone)/gi)
            let token = this.getParameterByName('token')
            let filter = this.getParameterByName('filter')
            let host = this.getParameterByName('host')
            let single = this.getParameterByName('single')
            let encHost = this.getParameterByName('imap')
            if (token) {
                dao.init(token, filter, host, single, encHost);
                await this.getLocales();
                await this.getUXD();
                await this.cleanupCookies();
                this.appendTheme();
            }
        },
        mounted() {
            this.$nextTick(() => {
                window.addEventListener('resize', this.onResize);
                window.addEventListener('load', () => {
                  this.notifyLayerLoaded();
                });
                window.addEventListener('message', (event) => {
                  this.processTaskMessage(event.data);
                });
            });
            window.addEventListener(
              "orientationchange",
              this.handleOrientationChange
            );
            window.addEventListener('email_cart_icon_count_changed', (event) => {
              document.getElementById("countEmailItems").innerHTML = event.detail.itemcount;
            });
            // Automatically convert user-defined call parameters into user cookies
            let reserved = ["token", "cache", "protocol", "host", "imap", "port", "drawing", "filter"];
            for (const p of new URLSearchParams(window.location.href)) {
              if(!p[0].startsWith("http:") && !p[0].startsWith("https:")) {
                if(!reserved.includes(p[0])) {
                  if(p[0] == "forceroot" && p[1].startsWith("true")) {
                    window.localStorage.setItem('partId', -1);
                    window.localStorage.setItem('drawingId', -1);
                  } else {
                    window.sessionStorage.setItem('uc_' + p[0], p[1].replace(/\/$/, '').replace('#', ''));
                  }
                }
              }
            }
            EventBus.$on('open-order-dialog', () => {
              this.orderColumnValue = this.project.orderColumnValue;
              this.orderDialog = true;
            });
            EventBus.$on('open-search-dialog', () => {
              this.searchDialog = true;
            });
            EventBus.$on('open-locale-dialog', () => {
              this.localeValue = this.project.selectedLocale;
              this.localeDialog = true;
            });


        },
        beforeDestroy() {
            window.removeEventListener('resize', this.onResize);
        },

    }
</script>
